export default {
  epc: 'RFID EPC',
  scanResult: 'Scan Result',
  upc: 'UPC',
  style: 'Style',
  size: 'Size',
  markFor: 'Mark For',
  soldTo: 'Sold To',
  shipTo: 'Ship To',
  obScanTime: 'OB Time',
  obScanTimeForReport: 'OB Scan Time',
  scanRecord: 'Scan Record',
  total: 'Total',
  results: 'Results',
  operator: 'Operator',
  gmScanTime: 'GM Scan Time',
  qty: 'Qty',
  scan: 'Scan',
  scanPlaceholder: 'Please scan/input RFID EPC',
  scanPlaceholderForWeb: 'Please input RFID EPC',
  stopScan: 'Stop',
  devicePower: 'Device Power',
  collapse: 'Collapse',
  expand: 'Expand',
  error1500: 'Wrong or non-existent RFID EPC',
  scanQrPlaceholder: 'Please scan/input QR Code',
  scanQrPlaceholderForWeb: 'Please input QR Code',
  invalidQRCodeFormat:
    'Invalid QR Code format, please try again. Correct format should be HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1.',
  tryAgain: 'Please try again.',
  qrCode: 'QR Code',
  switchTo: 'Switch to',
  scanTips1: '*Scan the GC local QR code first；if none is found on the shoe box, scan the Nike global QR code',
  scanTips2: '*Continue scanning the Nike global QR code；if not available, skip and proceed directly to search',
  qrCodeTips1: 'GC local QR code',
  qrCodeTips2: 'Nike global QR code',
  errorcode_5003: 'Only below QR Codes are supported.',
  globalQrCode: 'Global QR Code',
  localQrCode: 'Local QR Code'
}
